
export default function ProjectsStats() {
  const stats = [
    { value: "150+", label: "Proyectos Completados", icon: "ri-robot-2-line" },
    { value: "98%", label: "Clientes Satisfechos", icon: "ri-emotion-happy-line" },
    { value: "12", label: "Sectores Industriales", icon: "ri-building-2-line" },
    { value: "340%", label: "Eficiencia Media", icon: "ri-speed-up-line" }
  ];

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center p-6 md:p-8 rounded-2xl bg-gray-50 border border-gray-100 hover:border-orange-200 hover:shadow-lg transition-all duration-300 group cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-xl bg-gradient-to-br from-orange-500 to-green-500 group-hover:scale-110 transition-transform duration-300">
                <i className={`${stat.icon} text-white text-xl`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-black text-gray-900 mb-1">{stat.value}</div>
              <div className="text-xs md:text-sm text-gray-500 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
